const STYLE_ID = 'gpx-map-circle-pulse-styles'

/** Injects `@keyframes` once for {@link MapMarkerCircleStyle.pulse} (circle markers only). */
export function ensureCirclePulseStylesInjected(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = `
.gpx-map-circle-marker.gpx-map-circle-marker--pulse {
  animation: gpx-map-circle-pulse-ripple 2s ease-out infinite;
}
@keyframes gpx-map-circle-pulse-ripple {
  0% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--gpx-pulse-fill, #3b82f6) 55%, transparent);
  }
  65% {
    box-shadow: 0 0 0 18px transparent;
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
}
`
  document.head.appendChild(style)
}
